import React from 'react';
import { HierarchyFolder, TileInfo } from 'app/home/index.functions';
import { UserAuth } from 'store/auth';
import { Tile4FavoriteData } from 'app/home/index';
import { TileFavoriteIcon, TileFavoriteIconInfo } from 'app/home/tile/components/TileFavoriteIcon';
import { useHomeContext } from 'app/home/context';

export const TileFavorite = function ({
    style,
    defaultStyle,
    tile,
    tileicons,
    userauth,
    setTile4Favorite,
    favorites,
}: {
    style?: any;
    defaultStyle?: any;
    tile: TileInfo;
    tileicons?: { [key: string]: string };
    userauth: UserAuth;
    setTile4Favorite: (data: Tile4FavoriteData | null) => void;
    favorites: HierarchyFolder[];
}) {
    const ctx = useHomeContext();
    const [isEmbedded] = [ctx.isEmbedded];

    if (undefined === defaultStyle) {
        defaultStyle = {};
    }

    if (isEmbedded || tile.has_access == 'N') return null;

    return (
        <TileFavoriteIcon
            tile={tile as TileFavoriteIconInfo}
            setTile4Favorite={setTile4Favorite}
            favorites={favorites}
            defaultStyle={defaultStyle}
        />
    );
};
